import { sha1 } from "@noble/hashes/legacy.js";
import { sha256 } from "@noble/hashes/sha2.js";
import { bytesToHex, utf8ToBytes } from "@noble/hashes/utils.js";

const hashHex = (value: string, digest: (data: Uint8Array) => Uint8Array): string =>
  bytesToHex(digest(utf8ToBytes(value)));

export const sha1Hex = (value: string): string => hashHex(value, sha1);
export const sha256Hex = (value: string): string => hashHex(value, sha256);

export const matchesSha256Hex = (value: string, expectedHex: string): boolean => sha256Hex(value) === expectedHex;
